import PropTypes from 'prop-types'
import { usePage } from 'publisher/store'
import pageSelectors from 'publisher/store/page/pageSelectors'
import React from 'react'
import MetaTags from '../../components/core/MetaTags'
import { BlogOnExitPopup } from '../blog/blog-on-exit-popup'
import { BlogOnloadPopups } from '../blog/blog-onload-popups'
import { BlogTriggeredPopup } from '../blog/blog-triggered-popup'
import PageUi from '../ui/PageUi'

type BlogPageProps = {
  children: React.ReactNode
}

function BlogPage({ children }: BlogPageProps) {
  const globalTextFontProperties = usePage(
    pageSelectors.getGlobalFontProperties,
  )
  return (
    <PageUi
      $textFontFamily={globalTextFontProperties.fontFamily}
      $textFontWeight={globalTextFontProperties.fontWeight}
      $textFontStyle={globalTextFontProperties.fontStyle}
    >
      <MetaTags />
      {children}
      <BlogTriggeredPopup />
      <BlogOnExitPopup />
      <BlogOnloadPopups />
    </PageUi>
  )
}

BlogPage.propTypes = {
  children: PropTypes.node.isRequired,
}

export default BlogPage
